import styled from 'styled-components';

export const SkeletonBlock = styled.div<{ width?: string; height?: string }>`
  background: linear-gradient(
    90deg,
    #e8e8e8 25%,
    #f1f1f1 50%,
    #e8e8e8 75%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
  border-radius: 8px;
  width: ${(p) => p.width ?? '100%'};
  height: ${(p) => p.height ?? '1em'};

  @keyframes skeleton-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;

export const SkeletonContentWrapper = styled.div`
  padding-left: 12px;
  padding-right: 12px;
  @media (max-width: 500px) {
    margin-top: 10px;
  }
`;

export const SkeletonCard = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: start;
  padding: 14px;
  margin-top: 12px;
  background-color: #f1f1f1;
  border-radius: 10px;
`;

// Mirrors #page-menuonline + MainContainer so the skeleton sits where the menu will.
export const SkeletonPage = styled.div`
  display: flex;
  justify-content: center;
  min-height: 100vh;

  > main {
    width: 100%;
    max-width: 550px;
    background-color: #fff;
  }
`;

/* Mirrors EstablishmentHeaderV2: logo + name + rating pinned bottom-left over the cover. */
export const SkeletonHeader = styled(SkeletonBlock)`
  height: 235px;
  border-radius: 0;
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 0 20px 24px;
`;

export const SkeletonHeaderLogo = styled.div`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  border-radius: 8px;
  background-color: #f5f5f5;
`;

export const SkeletonHeaderLine = styled.div<{ width: string; height: string }>`
  width: ${(p) => p.width};
  height: ${(p) => p.height};
  margin-top: 8px;
  border-radius: 6px;
  background-color: #f5f5f5;
`;
